import { DataProviderCodes } from '@/common/enums/data-provider-codes';
import { ExternalDemographic } from '@/common/models';
import DataMarketplace from '@/common/models/misc-api-models/DataMarketplace';

export interface IDataProviderApi {
  dataprovider_id: number;
  datamarketplace_id?: number;
  name: string;
  url: string;
  code?: string;
  datamarketplace?: DataMarketplace;
}

export default class DataProvider {
  id: number;
  name: string;
  url: string;
  code: DataProviderCodes;
  externalDemographics: ExternalDemographic[];
  selectedExternalDemographics: ExternalDemographic[];
  dataMarketplaceID?: number;
  dataMarketplace?: DataMarketplace;

  constructor(
    id: number,
    name: string,
    url: string,
    code: string,
    dataMarketplaceID?: number,
    dataMarketplace?: DataMarketplace,
  ) {
    this.id = id;
    this.name = name;
    this.url = url;
    this.code = code as DataProviderCodes;
    this.externalDemographics = [];
    this.selectedExternalDemographics = [];
    this.dataMarketplaceID = dataMarketplaceID;
    this.dataMarketplace = dataMarketplace;
  }

  static fromApi(apiObject: IDataProviderApi): DataProvider {
    return new DataProvider(
      apiObject.dataprovider_id,
      apiObject.name,
      apiObject.url,
      apiObject.code,
      apiObject.datamarketplace_id,
    );
  }

  toApi(): IDataProviderApi {
    return {
      dataprovider_id: this.id || undefined,
      name: this.name,
      url: this.url,
    };
  }
}
